import * as React from 'react';
import { GdsAggregationServiceGroup } from '../../../../types';
import ServicesFactory from './ServicesFactory';
import { useSelector } from 'react-redux';

import { NASProductCategory, OrderStatus } from '@websky/graphql';
import { useConfig } from '../../../../../context';
import { getOrderStatus } from '../../../../store/order/selectors';

interface Props {
	services: GdsAggregationServiceGroup[];
	segmentId: string;
}

const Services: React.FC<Props> = ({ services, segmentId }) => {
	const status = useSelector(getOrderStatus),
		{ nasServiceUpsaleForConfirmedOrder } = useConfig().Engine;

	const filteredServices = services.filter(service => {
		if (
			service.type === NASProductCategory.fast_track ||
			service.type === NASProductCategory.lounge ||
			service.type === NASProductCategory.meet_and_greet ||
			service.type === NASProductCategory.vip
		) {
			return (
				status === OrderStatus.New ||
				status === OrderStatus.Booked ||
				service.selectedServices.length > 0 ||
				(nasServiceUpsaleForConfirmedOrder && status !== OrderStatus.Cancelled)
			);
		}

		return true;
	});

	return (
		<>
			{filteredServices.map(service => (
				<ServicesFactory key={`${service.type}/${segmentId}`} service={service} segmentId={segmentId} />
			))}
		</>
	);
};

export default Services;
